import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import { servicesContent } from "../data/servicesContent";
import { ModelOrgChart } from "./model/ModelOrgChart";
import { ModelFeeCard } from "./model/ModelFeeCard";
import { ServiceAreaDialog } from "./ServiceAreaDialog";
import useReveal from "../hooks/useReveal";
import "./model/model.css";

// Home chart order [Desarrollo, Marketing, Comunicación, Tech] -> services area index
const AREA_SERVICE_INDEX = [1, 3, 2, 4];

const ModelSection = ({ onBook }) => {
  const { lang } = useLanguage();
  const t = content[lang].model;
  const svc = servicesContent[lang].list[0];
  const labels = servicesContent[lang].labels;
  const ref = useReveal({ threshold: 0.04 });
  const [openIndex, setOpenIndex] = useState(null);

  const openArea = (serviceIndex) => setOpenIndex(serviceIndex);
  const navigate = (dir) =>
    setOpenIndex((i) => {
      if (i === null) return i;
      const total = svc.areas.length;
      return (i + dir + total) % total;
    });

  return (
    <section id="modelo" className="model-section" aria-labelledby="model-title" data-testid="model-section-container">
      <div ref={ref} className="model-layout reveal" data-testid="model-layout">
        <div className="model-main">
          <header className="model-intro" data-testid="model-heading">
            <p className="model-kicker" data-testid="model-kicker">{t.kicker}</p>
            <h2 id="model-title" className="model-title" data-testid="model-title">
              <span data-testid="model-title-first-line">{t.title}</span>
              <span data-testid="model-title-second-line">
                {t.titleSecondLine} <em data-testid="model-title-accent">{t.titleAccent}</em>
              </span>
            </h2>
            <p className="model-description" data-testid="model-description">{t.body}</p>
            <p className="mt-3 text-sm text-narwhal-muted" data-testid="model-pillar-link">
              {lang === "en" ? "Learn more about our " : "Conocé más sobre nuestra "}
              <Link to="/direccion-comercial-externa" className="text-narwhal-teal underline-offset-2 hover:underline">
                {lang === "en" ? "External Commercial Direction" : "Dirección Comercial Externa"}
              </Link>.
            </p>
          </header>
          <ModelOrgChart
            chart={t.chart}
            onRootOpen={() => openArea(0)}
            onAreaOpen={(index) => openArea(AREA_SERVICE_INDEX[index])}
          />
        </div>
        <ModelFeeCard price={t.price} onBook={onBook} />
      </div>

      <ServiceAreaDialog
        areas={svc.areas}
        index={openIndex}
        labels={labels}
        open={openIndex !== null}
        onOpenChange={(v) => { if (!v) setOpenIndex(null); }}
        onNavigate={navigate}
      />
    </section>
  );
};

export default ModelSection;
